module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [(_vm.type === 'notice') ? _vm._l((_vm.noticeList), function(notice, index) {
    return (notice.isShow) ? _c('div', {
      key: index
    }, [_c('t-notice', {
      attrs: {
        "prefix-cls": _vm.prefixCls,
        "styles": notice.styles,
        "content": notice.content,
        "duration": notice.duration,
        "closable": notice.closable,
        "name": notice.name,
        "time-out-id": notice.timeOutId,
        "transition-name": notice.transitionName,
        "on-close": notice.onClose
      },
      on: {
        "notice-time-out": _vm.onTimeOutChange
      }
    })], 1) : _vm._e()
  }) : _vm._l((_vm.notices), function(notice, index) {
    return (notice.isShow) ? _c('div', {
      key: index
    }, [_c('t-notice', {
      attrs: {
        "prefix-cls": _vm.prefixCls,
        "styles": notice.styles,
        "content": notice.content,
        "duration": notice.duration,
        "closable": notice.closable,
        "name": notice.name,
        "time-out-id": notice.timeOutId,
        "transition-name": notice.transitionName,
        "on-close": notice.onClose
      },
      on: {
        "notice-time-out": _vm.onTimeOutChange
      }
    })], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46471926"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/notification/notification.vue
// module id = 368
// module chunks = 0